export const trBadWords = [
    "orospu",
    "göt",
    "sik",
    "sikeyim",
    "siktir",
    "yarrak",
    "yarak",
    "amına",
    "amını",
];
